import { ContainerLoader } from "../../common/components/loaders/ContainerLoader";
import { useRequestMagicLink } from "../../common/hooks/firebaseHooks";
import { authedSessionSelectors } from "../../common/store/slice/authedSessionSlice";
import LoginFormView from "./LoginFormView";
import MagicLinkErrorModal from "./MagicLinkErrorModal";
import MagicLinkRequestedModal from "./MagicLinkRequestedModal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const LoginPage = (): JSX.Element => {
  const user = useSelector(authedSessionSelectors.user);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  const {
    requestMagicLink,
    state: {
      success: isMagicLinkRequested,
      loading: isRequestingMagicLink,
      error: magicLinkError,
    },
  } = useRequestMagicLink();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/account");
  });

  return (
    <ContainerLoader loading={isRequestingMagicLink}>
      <LoginFormView
        onSubmitEmail={(email: string) => {
          requestMagicLink(email);
          setFormSubmitted(true);
        }}
      />
      <MagicLinkErrorModal
        open={magicLinkError && formSubmitted}
        onClose={() => {
          setFormSubmitted(false);
        }}
      />
      <MagicLinkRequestedModal
        open={isMagicLinkRequested && !magicLinkError && formSubmitted}
        onClose={() => {
          setFormSubmitted(false);
        }}
      />
    </ContainerLoader>
  );
};
